<template>
  <section>
    <router-view />
  </section>
</template>

<script>
export default {
  name: 'cat-card-show',
};
</script>

<style lang="scss" scoped>
  .card-cover {
    display: block;
    max-width: 570px;

    margin: 0 auto;
    padding: percentage(60px/360px) 32px;

    color: #fff;
  }
</style>
